import { __rest } from "tslib";
import * as React from 'react';
export var TabButton = function TabButton(_a) {
  var children = _a.children,
      tabContentRef = _a.tabContentRef,
      props = __rest(_a, ["children", "tabContentRef"]);

  var Component = props.href ? 'a' : 'button';
  return React.createElement(Component, Object.assign({}, props), children);
};